import { render } from "./DashboardUser.vue?vue&type=template&id=ffce239c&scoped=true"
import script from "./DashboardUser.vue?vue&type=script&lang=js"
export * from "./DashboardUser.vue?vue&type=script&lang=js"

import "./DashboardUser.vue?vue&type=style&index=0&id=ffce239c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffce239c"]])

export default __exports__